import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';

import { IAddressDetailViewModel } from '../model/Location.model';
import { IAirportCodeList, IGetLocationViewModel, IGetServiceLocationViewModel } from './vehicle.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  // todo need to refactor to remove serviceLocationList$ and airportCodeList$
  serviceLocationList$ = new BehaviorSubject<IGetLocationViewModel[]>([]);
  airportCodeList$ = new BehaviorSubject<IAirportCodeList[]>([]);

  constructor(private httpClient: HttpClient) {}

  getAllAirportCodeList(): Observable<IAirportCodeList[]> {
    const url = `${environment.apiHost}/Address/GetAllAirportCodeList`;

    return this.httpClient
      .get<IAirportCodeList[]>(url)
      .pipe(
        tap((airportCodeList: IAirportCodeList[]) => {
          // todo need to refactor this stuff later
          this.airportCodeList$.next(airportCodeList);
        }),
      )
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  GetLocationByLegIdList(legIdList: string[]): Observable<IAddressDetailViewModel[]> {
    const url = `${environment.apiHost}/Address/GetLocationByLegIdList`;

    return this.httpClient
      .post<IAddressDetailViewModel[]>(url, legIdList)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getServiceLocations(): Observable<IGetServiceLocationViewModel[]> {
    const url = `${environment.apiHost}/Address/GetAllSRAddresses`;
    return this.httpClient.get<IGetServiceLocationViewModel[]>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getAllServiceLocations(): Observable<IGetLocationViewModel[]> {
    const url = `${environment.apiUrl}/ServiceRequest/GetAllLocation`;

    return this.httpClient.get<IGetLocationViewModel[]>(url).pipe(
      tap((serviceLocationList: IGetLocationViewModel[]) => {
        // todo need to refactor these stuff later
        const filteredServiceLocationList = serviceLocationList
          ? serviceLocationList.filter(
              (x) => x.addressName != null && x.addressName !== '' && x.latitude != null && x.longitude != null && x.isActive === true,
            )
          : [];
        this.serviceLocationList$.next(filteredServiceLocationList);
      }),
      map((response: IGetLocationViewModel[]) =>
        response.filter(
          (x) => x.addressName != null && x.addressName !== '' && x.latitude != null && x.longitude != null && x.isActive === true,
        ),
      ),
    );
  }
}
